import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
    section: number;
    question: number;
    _type: number;
    value_type: number;
    value: string | null;
}

export const useCreateCondition = () => {
    const { authHeader } = useAuth();

    return useMutation((params: Params) => {
        return axios.post(`${env.verifyServiceUrl}individual/section_condition/`, params, {
            headers: {
                Authorization: authHeader,
            },
        });
    });
};
